import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import ProductCard from "./ProductCard";
import { useContext } from "react";
import Loader from "../../Shared/Loader/Loader";
import { AuthContext } from "../../Contexts/AuthProvider/AuthProvider";
import ProductsCategorySideBar from "../../components/ProductsCategorySideBar/ProductsCategorySideBar";
import { Link } from "react-router-dom";
import { Label, TextInput } from "flowbite-react";
const AllProducts = () => {
  const [products, setProducts] = useState([]);
  const [itemOffset, setItemOffset] = useState(0);
  const [search, setSearch] = useState("");
  // const { loading } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    fetch("https://shadin-organic-server.vercel.app/products")
      .then((res) => res.json())
      .then((data) => {
        // console.log(data);
        const availableProducts = data.filter(
          (product) => product.product_status === "Available"
        );
        setProducts(availableProducts);
        setLoading(false);
      });
  }, []);

  let searchData;
  if (search) {
    searchData = products?.filter(
      (product) =>
        product.product_name.toLowerCase().includes(search.toLowerCase()) ||
        product.category.toLowerCase().includes(search.toLowerCase()) ||
        product.price.toLowerCase().includes(search.toLowerCase()) ||
        product._id.includes(search)
    );
  } else {
    searchData = products;
  }

  const itemsPerPage = 6;

  const endOffset = itemOffset + itemsPerPage;

  const currentItems = searchData.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(searchData.length / itemsPerPage);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % searchData.length;
    // console.log(
    //     `User requested page number ${event.selected}, which is offset ${newOffset}`
    // );
    setItemOffset(newOffset);
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="max-w-[1920px] mx-auto">
      <div className="flex ">
        <ProductsCategorySideBar />
        <div className=" w-full p-6  bg-gray-100">
          {products.length === 0 ? (
            <section className="flex items-center sm:p-16 bg-gray-50 text-gray-800">
              <div className="container flex flex-col items-center justify-center px-5 mx-auto my-8 space-y-8 text-center sm:max-w-md">
                <svgc
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                  className="w-40 h-40 text-gray-400"
                >
                  <path
                    fill="currentColor"
                    d="M256,16C123.452,16,16,123.452,16,256S123.452,496,256,496,496,388.548,496,256,388.548,16,256,16ZM403.078,403.078a207.253,207.253,0,1,1,44.589-66.125A207.332,207.332,0,0,1,403.078,403.078Z"
                  ></path>
                  <rect
                    width="176"
                    height="32"
                    x="168"
                    y="320"
                    fill="currentColor"
                  ></rect>
                  <polygon
                    fill="currentColor"
                    points="210.63 228.042 186.588 206.671 207.958 182.63 184.042 161.37 162.671 185.412 138.63 164.042 117.37 187.958 141.412 209.329 120.042 233.37 143.958 254.63 165.329 230.588 189.37 251.958 210.63 228.042"
                  ></polygon>
                  <polygon
                    fill="currentColor"
                    points="383.958 182.63 360.042 161.37 338.671 185.412 314.63 164.042 293.37 187.958 317.412 209.329 296.042 233.37 319.958 254.63 341.329 230.588 365.37 251.958 386.63 228.042 362.588 206.671 383.958 182.63"
                  ></polygon>
                </svgc>
                <p className="text-3xl">
                  Looks like our this category products are currently offline!
                  Check different category.
                </p>
                <Link
                  to="/category/all"
                  rel="noopener noreferrer"
                  href="#"
                  className="px-8 py-3 font-semibold rounded bg-orange-600 text-gray-50 hover:scale-105 duration-100"
                >
                  Back to shopping
                </Link>
              </div>
            </section>
          ) : (
            <div>
              <h3 className="text-gray-800 font-semibold text-lg">
                Total {searchData.length} products{" "}
              </h3>
              <div>
                <div className="mb-2 block">
                  <Label name="search" className="text-gray-800 text-lg ">
                    Search product by name or category or color or price or id
                  </Label>
                </div>
                <TextInput
                  id="search"
                  placeholder="Search product..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  type="text"
                  className="max-w-xl w-11/12"
                />
              </div>
              <div className="grid lg:grid-cols-3  xl:grid-cols-4 md:grid-cols-2 sm:grid-cols-2 grid-cols-1 lg:gap-6 md:gap-4 gap-6 mt-6">
                {currentItems?.map((product) => (
                  <ProductCard key={product?._id} product={product} />
                ))}
              </div>
            </div>
          )}

          <div className="pagination mt-6">
            <ReactPaginate
              breakLabel="..."
              nextLabel=">"
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={pageCount}
              previousLabel="<"
              renderOnZeroPageCount={null}
              containerClassName="pagination-menu"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllProducts;
